import React from "react";
import { Link, useParams } from "react-router-dom";
import {
  Grid,
  Container,
  Typography,
  Box,
  Button,
  Breadcrumbs,
} from "@material-ui/core";
import { NavigateNext } from "@material-ui/icons";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import Footer from "../footer/Footer";
import ProjectItem from "../shared/projectItem/projectItem";
import OrderSummary from "../shared/orderSummary/OrderSummary";
import {
  useStyles,
  InvestmentProcedureLogic,
  InvestmentProcedureService,
} from "./investmentProcedure.module";
import { ProjectDetailService } from "../ProjectDetail/projectDetail.module";
import AlertMessage from "../shared/alert/alert";

const InvestmentProcedure = () => {
  const classes = useStyles();
  const { id } = useParams();
  const service = InvestmentProcedureService();
  const {
    handleReturn,
    goToBilling,
    setCoinsFromChild,
    setTypeFromChild,
    values,
    errors,
    translator,
  } = InvestmentProcedureLogic(
    () => ProjectDetailService().getProject(id),
    service.createTransaction,
    service.createSessionInStripe
  );

  const [projectItemValues, setProjectItemValues] = React.useState({
    price: 0,
    counter: 1,
    fee: 0,
    total: 0,
  });

  return (
    <div>
      <Box className={classes.breadcrumbContainer}>
        <Breadcrumbs
          separator={<NavigateNext fontSize="small" />}
          aria-label="breadcrumb"
        >
          <Link className={classes.customLink} to="/">
            <Typography className={classes.fontLink}>
              {translator("breadcrumbs_home")}
            </Typography>
          </Link>
          <Link className={classes.customLink} to="/projects">
            <Typography className={classes.fontLink}>
              {translator("breadcrumbs_projects")}
            </Typography>
          </Link>
          <Link className={classes.customLink} to={`/investment/${id}`}>
            <Typography className={classes.fontLink}>
              {translator("breadcrumbs_investment")}
            </Typography>
          </Link>
        </Breadcrumbs>
      </Box>
      <Container maxWidth="lg" className={classes.pageContainer}>
        <Box className={classes.headerBox}>
          <Typography className={classes.pageTitle}>
            Review <span className={classes.titleHighlight}>Selection</span>
          </Typography>
          <Typography className={classes.pageDescription}>
            Verify your carbon asset allocation. Each credit represents one
            metric ton of CO2 sequestered through verified forest preservation.
          </Typography>
        </Box>

        <Grid container spacing={4} className={classes.mainContent}>
          <Grid item xs={12} md={7}>
            <Box className={classes.leftColumn}>
              <ProjectItem
                project={values.project}
                setCoins={setCoinsFromChild}
                setType={setTypeFromChild}
                onValuesChange={setProjectItemValues}
              />

              <Typography className={classes.disclaimerText}>
                {translator("investment_description")}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={5}>
            <Box className={classes.rightColumn}>
              <OrderSummary
                price={projectItemValues.price}
                counter={projectItemValues.counter}
                fee={projectItemValues.fee}
                total={projectItemValues.total}
                translator={translator}
              />

              <Box className={classes.buttonsContainer}>
                <Button
                  fullWidth
                  variant="outlined"
                  className={classes.continueButton}
                  onClick={goToBilling}
                  disabled={!values.success}
                  endIcon={<ArrowRightAltIcon />}
                >
                  {translator("investment_continue_button")}
                </Button>

                <Button
                  fullWidth
                  variant="outlined"
                  className={classes.backButton}
                  onClick={handleReturn}
                >
                  {translator("investment_go_back_button")}
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {errors && errors.api_error && (
          <Box className={classes.alertContainer}>
            <AlertMessage type="error" text={errors.api_error} />
          </Box>
        )}
      </Container>

      <Footer />
    </div>
  );
};

export default InvestmentProcedure;
